import React, { Component } from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import isEqual from "lodash.isequal";
import AutoComplete from "material-ui/AutoComplete";
import { FieldTitle, translate } from "admin-on-rest";

export class AutocompleteInput extends Component {
  state = {};

  componentWillMount() {
    this.setSearchText(this.props);
  }

  componentDidMount() {
    const fetchedSource = this.props.choices.find(
      choice => get(choice, "name") === this.props.defaultValue
    );

    if (fetchedSource) {
      if (isEqual(this.state.searchText, fetchedSource.name)) {
        this.props.input.onChange(fetchedSource.id);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.choices, nextProps.choices)) {
      return;
    }

    if (
      !this.props.isFilter &&
      this.state.searchText === "" &&
      this.props.input === nextProps.input
    )
      this.props.input.onChange("");

    // if you just type in an existing value, select it
    if (nextProps.input.value) {
      const { choices } = this.props;
      const { input } = nextProps;
      choices.forEach((choice, index) => {
        if (choice.name === input.value) {
          this.handleNewRequest(choice.name, index);
        } else if (choice.first_name + " " + choice.last_name === input.value) {
          const request = {
            text: choice.first_name + " " + choice.last_name,
            value: choice.id
          };
          this.handleNewRequest(request, index + 1);
        }
      });
    } else {
      return;
    }
  }

  setSearchText(props) {
    const { choices, input, optionValue } = props;

    const selectedSource = choices.find(
      choice => get(choice, optionValue) === input.value
    );

    const fetchedSource = choices.find(
      choice => get(choice, "name") === props.defaultValue
    );

    const searchText =
      (selectedSource && this.getSuggestion(selectedSource)) ||
      (this.props.defaultValue ? this.getSuggestion(fetchedSource) : "");
    this.setState({ searchText });
  }

  handleNewRequest = (chosenRequest, index) => {
    const { allowEmpty, choices, input, optionValue } = this.props;
    let choiceIndex = allowEmpty ? index - 1 : index;

    // The empty item is always at first position
    if (allowEmpty && index === 0) {
      return input.onChange("");
    }

    // if the value was just typed in and not selected the choiceIndex is -1
    if (choiceIndex === -1) {
      const requestChoice = choices.filter((choice, index) => {
        if (
          choice.first_name + " " + choice.last_name === chosenRequest ||
          choice.name === chosenRequest
        ) {
          return choice.id;
        }
        return null;
      });
      if (requestChoice[0] && requestChoice[0].id) {
        return input.onChange(requestChoice[0].id);
      } else {
        return input.onChange("");
      }
    }

    this.setState({ searchText: chosenRequest.text })


    input.onChange(choices[choiceIndex][optionValue]);
  };

  handleUpdateInput = searchText => {
    this.setState({ searchText });
    const { setFilter } = this.props;
    setFilter && setFilter(searchText);
  };

  getSuggestion(choice) {
    const { optionText, translate, translateChoice } = this.props;
    const choiceName =
      typeof optionText === "function"
        ? optionText(choice)
        : get(choice, optionText);
    return translateChoice
      ? translate(choiceName, { _: choiceName })
      : choiceName;
  }

  addAllowEmpty = choices => {
    const { allowEmpty, translate } = this.props;

    if (allowEmpty) {
      return [
        {
          value: "",
          text: translate("aor.input.autocomplete.none")
        },
        ...choices
      ];
    }

    return choices;
  };

  handleBlur() {
    const { setFilter } = this.props;
    this.setState({ searchText: '' });
    this.props.input.onChange("");
    setFilter && setFilter('');
  };

  render() {
    const {
      choices,
      elStyle,
      filter,
      isRequired,
      label,
      meta,
      options,
      optionValue,
      resource,
      source,
      customTextFieldStyle,
      inputStyle,
      floatingLabelStyle,
      underlineStyle,
      underlineFocusStyle,
      underlineShow,
      hintStyle
    } = this.props;
    if (typeof meta === "undefined") {
      throw new Error(
        "The AutocompleteInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const { touched, error } = meta;

    if (this.state.value) this.props.input.value = this.state.value;

    const dataSource = this.addAllowEmpty(
      choices.map(choice => ({
        value: get(choice, optionValue),
        text: this.getSuggestion(choice)
      }))
    );

    const menuProps = {
      maxHeight: 300
    };

    return (
      <AutoComplete
        searchText={this.state.searchText}
        dataSource={dataSource}
        onBlur={(e) => this.handleBlur()}
        floatingLabelText={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        filter={filter}
        onNewRequest={this.handleNewRequest}
        onUpdateInput={this.handleUpdateInput}
        openOnFocus
        style={elStyle}
        textFieldStyle={customTextFieldStyle}
        errorText={touched && error}
        menuProps={menuProps}
        {...options}
        inputStyle={inputStyle}
        floatingLabelStyle={floatingLabelStyle}
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
        underlineShow={underlineShow}
        hintStyle={hintStyle}
      />
    );
  }
}

AutocompleteInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  allowEmpty: PropTypes.bool.isRequired,
  choices: PropTypes.arrayOf(PropTypes.object),
  elStyle: PropTypes.object,
  filter: PropTypes.func.isRequired,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  onBlur: PropTypes.func,
  options: PropTypes.object,
  optionElement: PropTypes.element,
  optionText: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
    .isRequired,
  optionValue: PropTypes.string.isRequired,
  resource: PropTypes.string,
  setFilter: PropTypes.func,
  source: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool.isRequired
};

AutocompleteInput.defaultProps = {
  addField: true,
  choices: [],
  filter: AutoComplete.fuzzyFilter,
  onBlur: () => { },
  options: {},
  optionText: "name",
  optionValue: "id",
  translateChoice: true
};

export default translate(AutocompleteInput);


// WEBPACK FOOTER //
// ./src/components/CRM/AutocompleteInput.js